<template>
    <CompassCallout :title="translations.title" icon="success-circle-fill" :items="benefits" />
</template>

<script>
export default {
    props: {
        benefits: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationWizardOverviewBenefits.title'),
            },
        };
    },
};
</script>
